var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { class: { "mobile-spacer": _vm.isMobile } }),
    _vm._v(" "),
    _c("div", { class: { "mobile-container": _vm.isMobile } }, [
      _vm.isMobile
        ? _c("div", { staticClass: "container-total-compra" }, [
            _c("div", [
              _c("strong", { key: _vm.subTotal }, [
                _vm._v(
                  "\n          Subtotal: " +
                    _vm._s(_vm.formatMoney(_vm.subTotal)) +
                    "\n        "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column justify-content-center align-items-center",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { type: "button", disabled: _vm.disableNext },
                  on: { click: _vm.next },
                },
                [
                  _vm.loading
                    ? _c("strong", [
                        _c("i", { staticClass: "fa-regular fa-hourglass" }),
                      ])
                    : _c("strong", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.isFinish ? "Adicionar ao carrinho" : "Próximo"
                            ) +
                            "\n        "
                        ),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn back mt-2",
                  style: {
                    visibility: _vm.disablePrevius ? "hidden" : "visible",
                  },
                  attrs: { type: "button", disabled: _vm.disablePrevius },
                  on: { click: _vm.previus },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n          Voltar para a etapa anterior\n        "
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center",
              staticStyle: { "background-color": "white" },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn",
                  style: {
                    visibility: _vm.disablePrevius ? "hidden" : "visible",
                  },
                  attrs: { type: "button", disabled: _vm.disablePrevius },
                  on: { click: _vm.previus },
                },
                [_c("strong", [_vm._v("\n          Anterior\n        ")])]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { type: "button", disabled: _vm.disableNext },
                  on: { click: _vm.next },
                },
                [
                  _vm.loading
                    ? _c("strong", [
                        _c("i", { staticClass: "fa-regular fa-hourglass" }),
                      ])
                    : _c("strong", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.isFinish ? "CONCLUIR" : "Próximo") +
                            "\n        "
                        ),
                      ]),
                ]
              ),
            ]
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }